module.exports = __webpack_public_path__ + "static/media/RobertFisk.d8aeb1fa.wav";